import { render, staticRenderFns } from "./ReadFile.vue?vue&type=template&id=b78c5364"
import script from "./ReadFile.vue?vue&type=script&lang=js"
export * from "./ReadFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports